import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import PabReplanningService from '../../../../services/PABReplanningService';
import { ENUMS } from '../../../../utils/constants';
import ListUI from '../../../../components/UI/ListUI';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import { translate } from '../../../../utils/util';
import * as pabReplanningAction from '../../../../actions/pabReplanningAction';
import { Subtitle } from '../../../../components/UI/ComponentsUI';

const PabReplanningListPartNumber = (props) => {
    const [partNumbers, setPartNumbers] = useState([]);

    useEffect(() => {
        var filter = {
            supplierCode: props.filter.supplierCode,
            status: [
                ENUMS.eOrderStatus.Waiting.value,
            ]
        };

        props.getPartNumbers(filter, (data) => {
            setPartNumbers(data)
        });
        // eslint-disable-next-line
    }, []);

    const onSelectItemChange = (item) => {
        props.filter.supplierCode = item.supplierCode;
        props.filter.orderType = ENUMS.eOrderType.PabReplanning.value;
        props.filter.partNumber = item.partNumber;
        props.setFilter(props.filter);
    };

    const renderItem = (item) => {
        return (
            <div>

                <Link
                    className="row"
                    style={{ display: 'block' }}
                    to='../smallParts/orders'
                    onClick={() => {
                        onSelectItemChange(item);
                    }}
                >
                    <div className="input-field col s12">
                        <strong><span className="title sixth-text-color">{`${item.partNumber}`}</span></strong>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{`${item.partNumberDescription}`}</span>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>Qtd de Pedidos: {item.quantity}</span>
                    </div>
                </Link>
            </div>
        );
    }

    return (
        <div>
            <Breadcrumbs id="SmallPartsFilter" subtitles={[{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterBySupplier') }]} />

            <div className="container-fluid" style={{ marginTop: '20px', }}>
                <Subtitle truncate="true" label={props.history?.location?.state?.subtitle} />
                <ListUI
                    data={
                        partNumbers.map((item, index) => {
                            return (
                                renderItem(item, index)
                            );
                        })
                    } />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.pabReplanningReducer.filter,
        partNumbers: state.pabReplanningReducer.partNumbers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPartNumbers: (filter, callback) => {
            dispatch(PabReplanningService.getPartNumbers(filter, callback));
        },
        setFilter: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PabReplanningListPartNumber)));